<div class="frame-parent" [ngClass]="{ 'no-underline': hideUnderline }">
  <div class="frame-wrapper">
    <div class="frame-title">
      <ng-content></ng-content>
    </div>
  </div>
  @if (!hideUnderline) {
    <div class="rectangle-wrapper">
      <div class="frame-child"></div>
    </div>
  }
</div>
